export default __webpack_public_path__ + "static/s-03-a5200724c04e0fb4085b4ce2c507ea45.png";